var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGetModuleRecordQuery } from "@/store/api";
import { faCalendar, faPaperPlane, faPhone, faPhoneRotary, } from "@fortawesome/pro-solid-svg-icons";
import { useEffect, useState } from "react";
import { useLayout, usePopup } from "@/hooks/layout";
import ActionDownload from "./actionDownload";
import Preview from "@/components/widgets/list/preview";
var ListActions = function (_a) {
    var recordId = _a.recordId, moduleName = _a.moduleName;
    var response = useGetModuleRecordQuery({
        moduleName: moduleName,
        recordId: recordId,
    }).data;
    var _b = useState({}), dataRecord = _b[0], setDataRecord = _b[1];
    var _c = useState(false), isDocument = _c[0], setIsDocument = _c[1];
    useEffect(function () {
        var data = (response === null || response === void 0 ? void 0 : response.data) || {};
        var record = data.record || {};
        setDataRecord(record);
        setIsDocument(record.document_name && record.document_name.length > 0);
    }, [response]);
    var _d = useState(false), clicked = _d[0], setClicked = _d[1];
    var handleClick = function (value) {
        setClicked(value);
    };
    var layout = useLayout();
    var popup = usePopup();
    var renderPopupContact = (_jsxs("div", { children: [_jsx("p", __assign({ className: "text-red-200" }, { children: "Hellooo" })), _jsx("input", { type: "text" })] }));
    return (_jsxs("div", __assign({ className: "flex flex-row items-center justify-center " }, { children: [(moduleName === "Prospets" ||
                moduleName === "Accounts" ||
                moduleName === "Contacts") && (_jsxs(_Fragment, { children: [_jsx(FontAwesomeIcon, { icon: faPhoneRotary, className: "text-gray-300 hover:text-gray-500 m-1 cursor-pointer", onClick: function (e) {
                            window.location.href = "tel:".concat(dataRecord === null || dataRecord === void 0 ? void 0 : dataRecord.phone_fax);
                            e.preventDefault();
                        } }), _jsx(FontAwesomeIcon, { icon: faPhone, className: "text-gray-300 hover:text-gray-500 m-1 cursor-pointer", onClick: function (e) {
                            window.location.href = "tel:".concat(dataRecord === null || dataRecord === void 0 ? void 0 : dataRecord.phone_office);
                            e.preventDefault();
                        } }), _jsx(FontAwesomeIcon, { icon: faPaperPlane, className: "text-gray-300 hover:text-gray-500 m-1 cursor-pointer", onClick: function (e) {
                            window.location.href = "mailto:".concat(dataRecord.email1);
                            e.preventDefault();
                        } })] })), moduleName === "Meetings" && (_jsx(FontAwesomeIcon, { icon: faCalendar, className: "text-gray-300 hover:text-gray-500 m-1 cursor-pointer" })), (moduleName === "Notes" || moduleName === "Documents") && (_jsx(ActionDownload, { record: dataRecord, moduleName: moduleName })), _jsx(Preview, { record: [], recordId: recordId, module: moduleName || "", handleClick: handleClick, isInDrawer: true, color: "gray-300", paddingClassname: "2", className: "mx-1" })] })));
};
export default ListActions;
